import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityDoc4det } from "../../entity/EntityDoc4det";

export class DtoDoc4detsGetRes extends EntityDoc4det {
  public items: EntityDoc4det[]  = [];
}
